import React, {Component} from 'react';
import UserBox from '../../Helpers/User/UserBox';
import { observer } from "mobx-react";


class UserLabel extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="rad3 dib ofh bg-w2 lh10 mright5 mbottom5">
        <div className="dib vam">
          <UserBox
            avatar={this.props.info.user_table_avatar}
            nick={this.props.info.user_table_nick}
            size={20}
          />
        </div>
        <div className="dib vam pleft5 fs11 pright5">
          {this.props.info.user_table_nick}
        </div>
      </div>
    )
  }
}

export default observer(UserLabel);